<div class="container">
  <div class="search-and-filters">
    <div class="search-section">
      <h2>Staff List</h2>
      <app-search-filter
        [(value)]="searchText"
        searchStyle="gray"
        placeholder="Search"
        (valueChange)="onSearchInput($event)"
        class="search-filter"
      ></app-search-filter>
    </div>
    <div class="filter-buttons">
      <app-new-button
      id="filter-button"
      color="tonal"
      size="sm"
      iconStyle="outlined"
      customPadding="12px 18px"
      leftIcon="sort"
      customFontSize="14px"
        (clickHandler)="openFiltersModal()"
      >
        Apply Filters
      </app-new-button>
      <app-new-button
      id="add-new-button"
      color="blue"
      size="sm"
      leftIcon="add"
      customPadding="12px 18px"
      customFontSize="14px"
        (clickHandler)="addNewStaff()"
        [disabled]="!permissions?.USER_ADD"
        *ngIf="permissions?.USER_ADD !== undefined"
      >
        New User
      </app-new-button>
    </div>
  </div>
  
  <app-new-table
    [tableData]="tableData"
    [isLoading]="loading"
    (sortClickedEvent)="onSortClicked($event)"
    (rowClickedEvent)="onRowClicked($event)"
    (burgerMenuClickedEvent)="onBurgerMenuClicked($event)"
    (paginationEvent)="onPaginationEvent($event)"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
    (pageChanged)="onPageChanged($event)"
  >
  </app-new-table>
</div>
